import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { DesignContestDto } from "../../../../../../autogen/bff-api";
import { EmptyValue } from "./SummaryField";

export const DesignContestSummary = ({ contest }: { contest: DesignContestDto | null | undefined }) => {
  const { t } = useTranslation();
  if (!contest) return <EmptyValue text={t("Not set")} />;
  const criteria = (contest.juryCriteria ?? []).filter((criterion) => criterion.trim());
  const jury = contest.jury ?? [];
  const prizes = contest.prizes ?? [];

  return (
    <Box fontSize="sm">
      <Text>
        {contest.leadsToServiceContract == null
          ? t("Not stated whether a service contract follows")
          : contest.leadsToServiceContract
            ? t("A service contract with one of the winners follows")
            : t("Prizes or payments only, no service contract")}
      </Text>
      <Text>
        {contest.juryDecisionBinding === false
          ? t("The jury only gives an opinion, the contracting authority decides")
          : t("The jury's decision is binding on the contracting authority")}
      </Text>
      <Text fontWeight="medium" mt="2">
        {t("The jury's evaluation criteria")}
      </Text>
      {criteria.length > 0 ? (
        <UnorderedList>
          {criteria.map((criterion) => (
            <ListItem key={criterion}>{criterion}</ListItem>
          ))}
        </UnorderedList>
      ) : (
        <EmptyValue text={t("Not set")} />
      )}
      {contest.requiredParticipantQualification && (
        <Text mt="2">
          {t("Participants must hold: {{qualification}}", { qualification: contest.requiredParticipantQualification })}
        </Text>
      )}
      <Text fontWeight="medium" mt="2">
        {t("Jury members")}
      </Text>
      {jury.length > 0 ? (
        <UnorderedList>
          {jury.map((member, index) => (
            <ListItem key={`${member.name}-${index}`}>
              {[member.name, member.role].filter(Boolean).join(", ")}
            </ListItem>
          ))}
        </UnorderedList>
      ) : (
        <EmptyValue text={t("Not set")} />
      )}
      {prizes.length > 0 && (
        <>
          <Text fontWeight="medium" mt="2">
            {t("Prizes and payments")}
          </Text>
          <UnorderedList>
            {prizes.map((prize, index) => (
              <ListItem key={`${prize.description}-${index}`}>
                {prize.value?.value != null
                  ? `${prize.description} (${prize.value.value.toLocaleString("nb-NO")} ${prize.value.currency})`
                  : prize.description}
              </ListItem>
            ))}
          </UnorderedList>
        </>
      )}
    </Box>
  );
};
